/**
 * Class-name join. Deliberately NOT `tailwind-merge`: this app's colours come
 * from a closed token set, so there is no palette-collision problem to solve, and
 * a merge library would be a dependency that exists only to paper over
 * conflicting utilities we should not be writing.
 */
export type ClassValue = string | false | null | undefined;

export function cn(...values: ClassValue[]): string {
  return values.filter((value): value is string => typeof value === 'string' && value !== '').join(' ');
}
